export default "__VITE_ASSET__e0f1a6a0__"